<app-header></app-header>
<div class="main-app-wrapper">
  @if (!analytics.consentRequired()) {
    <router-outlet></router-outlet>
    @if (showRecommendations()) {
      <div class="recommendation-section">
        <app-recommendations></app-recommendations>
      </div>
    }
  }
</div>
